// Moved from src/features/ContactsFeature/slice.js. `name`/store key stay
// "contactsFeature" so redux-persist and the existing selector paths keep
// working unchanged. The old `contacts` array field is dropped - it was
// written every fetch via setContacts (see the old useContactsData.js) but
// never read anywhere; the page renders straight from useContactsData's own
// RTK Query result, same dead-mirror shape already found and dropped in
// every other migration this session.
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const DEFAULT_SORT = "-createdAt";

const initialState = {
  selectedContactsFilters: {
    sort: DEFAULT_SORT,
  },
};

const contactsFeatureSlice = createSlice({
  name: "contactsFeature",
  initialState,
  reducers: {
    // ADR-F005: replace
    updateSelectedContactsFilters: (state, action) => {
      state.selectedContactsFilters = action.payload;
    },
    resetSelectedContactsFilters: (state) => {
      state.selectedContactsFilters = {
        sort: DEFAULT_SORT,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.contactsFeature) {
        const persistedData = action.payload.contactsFeature;
        const persistedFilters = persistedData.selectedContactsFilters;
        return {
          ...state,
          ...persistedData,
          // ADR-F005: never null; always have sort
          selectedContactsFilters: {
            ...(persistedFilters && typeof persistedFilters === "object"
              ? persistedFilters
              : {}),
            sort: persistedFilters?.sort || DEFAULT_SORT,
          },
        };
      }
      return state;
    });
  },
});

export const {
  updateSelectedContactsFilters,
  resetSelectedContactsFilters,
} = contactsFeatureSlice.actions;

export default contactsFeatureSlice.reducer;
